import { Heading } from "monday-ui-react-core";
import styled from "styled-components";

import cppLogo from "@/assets/icons/icon-cpp.png";

interface Props {
  message: string;
}

export default function NoLicense({ message }: Props) {
  return (
    <NoLicenseWrapper>
      <img src={cppLogo} alt="Clone Plus - Copy Items Logo" />
      <Heading type={Heading.types.h3} value="Clone Plus - Copy Items - License required" />
      <LicenseText data-testid="license-block-message">{message}</LicenseText>
    </NoLicenseWrapper>
  );
}

const NoLicenseWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: var(--spacing-xxl);

  img {
    width: 120px;
  }
`;

const LicenseText = styled.span`
  text-align: center;
  font-size: 16px;
`;
